<template>
    <app-layout class="feed-page-template" >
        <FeedList :section="'none'"></FeedList>
    </app-layout>
</template>

<script>
import FeedList from '@/components/FeedListComponent'

export default {
  name: 'FeedComponent',
  components: {
    FeedList
  }
}
</script>
